"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class EnrollmentApi extends runtime.BaseAPI {
    /**
     * Get an in-progress Enrollment by ID
     */
    async getStateByIdRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling getStateById.');
        }
        if (requestParameters.enrollmentId === null || requestParameters.enrollmentId === undefined) {
            throw new runtime.RequiredError('enrollmentId', 'Required parameter requestParameters.enrollmentId was null or undefined when calling getStateById.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/state/{enrollmentId}`.replace(`{${"enrollmentId"}}`, encodeURIComponent(String(requestParameters.enrollmentId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentFromJSON(jsonValue));
    }
    /**
     * Get an in-progress Enrollment by ID
     */
    async getStateById(requestParameters) {
        const response = await this.getStateByIdRaw(requestParameters);
        return await response.value();
    }
    /**
     * Finds an enrollment by Application ID
     */
    async lookupStateByApplicationIdRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling lookupStateByApplicationId.');
        }
        if (requestParameters.applicationIdLookup === null || requestParameters.applicationIdLookup === undefined) {
            throw new runtime.RequiredError('applicationIdLookup', 'Required parameter requestParameters.applicationIdLookup was null or undefined when calling lookupStateByApplicationId.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/state/lookup/application-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.ApplicationIdLookupToJSON(requestParameters.applicationIdLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentMatchFromJSON(jsonValue));
    }
    /**
     * Finds an enrollment by Application ID
     */
    async lookupStateByApplicationId(requestParameters) {
        const response = await this.lookupStateByApplicationIdRaw(requestParameters);
        return await response.value();
    }
    /**
     * Finds an enrollment by biographics
     */
    async lookupStateByBiographicsRaw(requestParameters) {
        if (requestParameters.xCLEARCorrelationInfo === null || requestParameters.xCLEARCorrelationInfo === undefined) {
            throw new runtime.RequiredError('xCLEARCorrelationInfo', 'Required parameter requestParameters.xCLEARCorrelationInfo was null or undefined when calling lookupStateByBiographics.');
        }
        if (requestParameters.biographicsLookup === null || requestParameters.biographicsLookup === undefined) {
            throw new runtime.RequiredError('biographicsLookup', 'Required parameter requestParameters.biographicsLookup was null or undefined when calling lookupStateByBiographics.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xCLEARCorrelationInfo !== undefined && requestParameters.xCLEARCorrelationInfo !== null) {
            headerParameters['X-CLEAR-CorrelationInfo'] = String(requestParameters.xCLEARCorrelationInfo);
        }
        if (requestParameters.xAmznTraceId !== undefined && requestParameters.xAmznTraceId !== null) {
            headerParameters['X-Amzn-Trace-Id'] = String(requestParameters.xAmznTraceId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/protected/state/lookup/biographics`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: models_1.BiographicsLookupToJSON(requestParameters.biographicsLookup),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.EnrollmentMatchFromJSON(jsonValue));
    }
    /**
     * Finds an enrollment by biographics
     */
    async lookupStateByBiographics(requestParameters) {
        const response = await this.lookupStateByBiographicsRaw(requestParameters);
        return await response.value();
    }
}
exports.EnrollmentApi = EnrollmentApi;
//# sourceMappingURL=EnrollmentApi.js.map